import "./App.css";
import { Switch, Route } from "react-router-dom";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Users from "./pages/Users";
import Locations from "./pages/Locations";
import ProductCategories from "./pages/ProductCategories";
import Brands from "./pages/Brands";
import Products from "./pages/Products";
import Packages from "./pages/Packages";
import Purchasing from "./pages/Purchasing";
import Analytics from "./pages/Analytics";
import ExchangeRate from "./pages/ExchangeRate";
import DailySales from "./pages/DailySales";
import MonthlyAudit from "./pages/MonthlyAudit";
import WastedItems from "./pages/WastedItems";

import { shallowEqual, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";

const App = () => {
  const { user } = useSelector(
    (state) => ({
      user: state.auth.user,
    }),
    shallowEqual
  );
  const [authenticated, setAuthenticated] = useState(false);
  useEffect(() => {
    authChecking();
  }, [user]);
  useEffect(() => {
    authChecking();
  }, []);
  const authChecking = () => {
    console.log(user);
    if (user) {
      if (user.role) {
        if (user.role !== "none") {
          setAuthenticated(true);
        } else {
          window.location.href = "/";
        }
      } else {
        window.location.href = "/";
      }
    } else if (
      window.location.pathname !== "/" &&
      window.location.pathname !== "/register"
    ) {
      window.location.href = "/";
    }
  };

  return (
    <main>
      {authenticated ? (
        <Switch>
          {/* <Route exact path='/' component={Orders}/>
      <Route exact path='/inventory' component={Inventory}/>
      <Route exact path='/chat' component={Chat}/>
      {user && user.role == 'admin' ?
      <Route exact path='/analytics' component={Analytics}/>
      :null} */}

          <Route exact path="/" component={Packages} />

          {user &&
          (user.role == "admin" ||
            user.role == "warehouse" ||
            user.role == "manager") ? (
            <Route exact path="/purchasing" component={Purchasing} />
          ) : null}
          <Route exact path="/products" component={Products} />
          {user &&
          (user.role == "admin" ||
            user.role == "oic" ||
            user.role == "manager") ? (
            <Route exact path="/dailysales" component={DailySales} />
          ) : null}
          {user && (user.role == "warehouse" || user.role == "manager") ? (
            <Route exact path="/wasteditems" component={WastedItems} />
          ) : null}
          <Route exact path="/monthlyaudit" component={MonthlyAudit} />

          {user && user.role == "admin" ? (
            <Route exact path="/users" component={Users} />
          ) : null}
          {user && user.role == "admin" ? (
            <Route exact path="/locations" component={Locations} />
          ) : null}
          {user && user.role == "admin" ? (
            <Route exact path="/exchangerate" component={ExchangeRate} />
          ) : null}
          {user && user.role == "admin" ? (
            <Route
              exact
              path="/productcategories"
              component={ProductCategories}
            />
          ) : null}
          {user && user.role == "admin" ? (
            <Route exact path="/brands" component={Brands} />
          ) : null}
          {user && user.role == "admin" ? (
            <Route exact path="/analytics" component={Analytics} />
          ) : null}
        </Switch>
      ) : (
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/register" component={Register} />
        </Switch>
      )}
    </main>
  );
};

export default App;
